export default __webpack_public_path__ + "static/media/live_agent.3f667fa9.png";